/**
 * Emergency mode (docs/voiceFeature.md, UC-18): the curated first-aid checklist
 * per situation. Bundled with the app on purpose — it works offline and when
 * the API is down, costs nothing and is fixed content, not AI. Texts are i18n
 * keys: `emergency.situations.<key>.label|safety` and
 * `emergency.situations.<key>.steps.<step>`. Source and review status:
 * reef-knowledge research/emergency/reef-emergency-first-aid.md ("Content for
 * the app"); it must be reviewed by an experienced reefkeeper before release.
 * No numbers on purpose (no thresholds, doses or change rates).
 */
export const EMERGENCY_SITUATIONS = [
  {
    key: 'fish_distress',
    steps: ['aeration', 'equipment_running', 'temp_salinity', 'test_ammonia', 'stop_feeding', 'dead_animal', 'water_change', 'observe_quarantine'],
  },
  {
    key: 'coral_tissue_loss',
    steps: ['temp_salinity', 'test_alkalinity', 'recent_changes', 'carbon', 'pests_contact', 'siphon_dead_tissue', 'isolate_coral', 'photograph_daily'],
  },
  {
    key: 'parameter_swing',
    steps: ['stop_dosing', 'retest', 'temp_salinity', 'test_ph', 'ammonia_source', 'carbon', 'water_change', 'correct_gradually'],
  },
  {
    key: 'power_heater_failure',
    steps: ['move_water', 'unplug_stuck_heater', 'second_thermometer', 'no_feeding', 'keep_warm', 'cool_down', 'restart_check', 'ammonia_follow_up'],
  },
  {
    key: 'cloudy_toxin',
    steps: ['aeration', 'remove_source', 'temp_salinity_ammonia', 'carbon_metals', 'water_change_if_stressed', 'feed_lightly', 'watch_no_clarifier', 'move_stinging_coral'],
  },
] as const;

export type EmergencySituationKey = (typeof EMERGENCY_SITUATIONS)[number]['key'];

export function isEmergencySituation(value: string | null | undefined): value is EmergencySituationKey {
  return EMERGENCY_SITUATIONS.some((s) => s.key === value);
}

export function situationSteps(key: EmergencySituationKey): readonly string[] {
  return EMERGENCY_SITUATIONS.find((s) => s.key === key)!.steps;
}
